'use strict';

/* Controllers */

app.controller('CognitoLoginController', ['$scope', '$rootScope', '$location', 'Auth', 'Helper', 'User', 'Popup', 'AwsCognito', 'Preloader', 'env_config', 
    function ($scope, $rootScope, $location, Auth, Helper, User, Popup, AwsCognito, Preloader, env_config) {

        Auth.redirectIfLoggedIn();
        
        $scope.login_started = false;


        /**
         * called when user submits login form
         */
        $scope.loginUser = function() {

            if( $scope.login_started ) return;

            Preloader.open();

            $scope.login_started = true;

            AwsCognito.login($scope.username, $scope.password, false, function(resp, status, cognitoData) {

                Preloader.close();

                if(status == 200) {
                    // success
                    //Auth.setCredentials(resp.data.user);
                    
                    // set cognito credentials
                    AwsCognito.setCredentials(cognitoData, resp.data.user, resp.data.credits);
                    
                    // get credit
                    User.getCredit(function(){
                        
                        // this will go to intended or landing page
                        Auth.redirectIfLoggedIn();
                    });

                }
                else if(status == 403) {

                    // check if user was imported from our system to cognito
                    if(resp.data.message.code == 'PasswordResetRequiredException'){

                        //Popup.error(resp.data.message + "<br/>Please check email and update your password!", function(){
                        Popup.custom('Our recent improvements in security require some customers to renew their password.  Please take a moment to renew your password on the next screen.', 'Renew', function(){
                            // contact cognito to send an email with verification code to user
                            AwsCognito.forgotPassword($scope.username, function(err, data){
                                if(err){
                                    Popup.error(err);
                                }else{
                                    $rootScope.globals.email_forgot_password = $scope.username;
                                    $scope.$apply($location.path('/update-password'));
                                }

                                Preloader.close();
                                return ;

                            });
                        });
                        $scope.login_started = false;

                    } else if (resp.data.message.code == 'UserNotFoundException') {
                        Popup.error('The username and/or password is incorrect.');
                        $scope.login_started = false;     
                    } else {
                        Popup.error(resp.data.message);
                        $scope.login_started = false;
                    }
                }
                else if(status == 400 || status == 401) {
                    
                    switch(resp.data.code){
                        case 'EE1000':
                        case 'EE1001':
                            Popup.error('The username and/or password is incorrect.');
                            break;
                        case 'EE1002':
                            Popup.error('It looks like your account was deactivated.');
                            break;
                        default:
                            Popup.error(resp.data.message);
                    }
                    
                    $scope.login_started = false;
                }
                else if(status == 500) {
                    Popup.error('Something went wrong :(');
                    
                    $scope.login_started = false;
                }

            });
        };


        /**
         * called then user logins via facebook button
         */
        $scope.facebookLogin = function(){
            Preloader.open();
            FB.login(function (response) {
                // Check if the user logged in successfully.
                if (response.authResponse) {
                    // grant email
                    if (response.authResponse.grantedScopes.indexOf('email') == -1) {
                        Preloader.close();
                        Popup.error('Sorry, we are not able to retrieve your email address. Please check your Facebook settings.');
                    }
                    else {
                        AwsCognito.fbConnect(response.authResponse.accessToken, false, function(resp, status){
                            Preloader.close();
                            if (resp !== undefined) {
                                if( status == 200 ){
                                    var cognitoData = {
                                        'id_token': resp.data.user.cognito_id_token,
                                        'fb_token': resp.data.user.fb_token
                                        //'token_expired_time': resp.data.user.expiredDateTime
                                    };
                                    // success
                                    AwsCognito.setCredentials(cognitoData, resp.data.user, resp.data.credits);

                                    
                                    // get credit
                                    User.getCredit(function(){
                            
                                        // this will go to intended or landing page
                                        Auth.redirectIfLoggedIn();
                                    });
                                }
                                else if( status == 500 ){
                                    Popup.error('Facebook Login has not been supported yet');
                                }
                                else {
                                    Popup.error(resp.data.message);
                                }
                            }
                        });
                    }
                } else {
                    Preloader.close();
                    //Popup.error(Helper.getProperty(response, 'data.message'));
                }

            }, 
            {
                scope: 'email',
                return_scopes: true
            });
        };


        /**
         * called when user clicks on forgot password button
         */
        $scope.forgotCogPassword = function(){

            var email = $scope.username || '';

            // first do some simple validation
            if( email == '' ){
                Popup.error('Please enter your email address.');
                return;
            }
            if( ! Helper.validateEmail(email) ){
                Popup.error('Please enter a valid email address.');
                return;
            }

            Preloader.open();

            // contact cognito to send an email with verification code to user
            AwsCognito.forgotPassword(email, function(err, data){
                if (err) {
                    if (err == 'UserNotFoundException: Username/client id combination not found.') {
                        Popup.error('We could not find your account.  Please check that you have entered your username or email correctly and try again.');
                    }
                    else {
                        Popup.error(err);
                    }
                }else{
                    $rootScope.globals.email_forgot_password = email;
                    $scope.$apply($location.path('/update-password'));
                }

                Preloader.close();
                return ;

            });

        };

        /**
         * update password
         * */
        $scope.updateCogPassword = function(){

            Preloader.open();
            var email = $rootScope.globals.email_forgot_password;
            var newpassword = $scope.password;
            if (newpassword == undefined) {
                Popup.error("Please enter a password.");
                return;
            }
            var verificationCode = $scope.verificationcode;
            if (verificationCode == undefined) {
                Popup.error("Please enter the verification code we sent to your email address.");
                return;
            }

            // contact api to send an email with new password to user
            AwsCognito.updatePassword(email, newpassword, verificationCode, function(resp, status, cognitoData){
                
                if(status == 200) {
                    // set cognito credentials
                    AwsCognito.setCredentials(cognitoData, resp.data.user);

                    // get credit
                    User.getCredit(function(){

                        // this will go to intended or landing page
                        Auth.redirectIfLoggedIn();
                    });
                } else if(status == 403) {
                    Popup.error(resp.data.message);
                }
                else if( status == 500 ){
                    Popup.error(Helper.getProperty(resp, 'data.message'));
                } else {
                    if (resp == "CodeMismatchException: Invalid verification code provided, please try again.")
                        Popup.error("We didn't recognise the verification code you entered.");
                    else if (resp == "InvalidParameterException: 1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6") {
                        Popup.error("Password must have at least 6 characters.");
                    }
                    else {
                        Popup.error(resp);
                    }
                }
                Preloader.close();

                return ;

            });
        };

        $scope.googleLogin = function() {
            /**
             * The Sign-In client object.
             */
            var auth2;

            /**
             * Initializes the Sign-In client.
             */
            var initClient = function() {
                gapi.load('auth2', function(){
                    /**
                     * Retrieve the singleton for the GoogleAuth library and set up the
                     * client.
                     */
                    auth2 = gapi.auth2.getAuthInstance();
                    if (!auth2) {
                        auth2 = gapi.auth2.init({
                            client_id: env_config.google_app_id,
                            scope: 'profile'
                        });
                    }

                    console.log('G Login');
                    auth2.currentUser.listen(function(user) {
			            console.log('currentUser');
                        var currentToken, newToken, newAccessToken;
            			if ($rootScope.globals.awsCredentials !== undefined) {
            			   currentToken = $rootScope.globals.awsCredentials.gg_token;
            			}
            			if (user.getAuthResponse !== undefined) {
            			    newToken =  user.getAuthResponse().id_token;
                            newAccessToken = user.getAuthResponse().access_token;
                        }
    	                if (currentToken !== undefined  && currentToken != newToken) {
    			            AwsCognito.ggConnect(newToken, true, newAccessToken, function(resp, status){
    		                    if( status == 200 ){
                    		        var cognitoData = {
    		                            id_token: resp.data.user.cognito_id_token,
                    		            gg_token: resp.data.user.gg_token
    		                        };
    	
            		                // set cognito credentials
                           			 AwsCognito.setCredentials(cognitoData, resp.data.user, resp.data.credits);

    		                        // get credit
    		                        User.getCredit(function() {
    						            return true;
    					            });
                    		    }
    			            });
    		            }
 		            });

                    // Attach the click handler to the sign-in button
                    auth2.attachClickHandler('customBtn', {}, onSuccess, onFailure);
                });
            };

            /**
             * Handle successful sign-ins.
             */
            var onSuccess = function(user) {
                Preloader.open();
                var idToken = user.getAuthResponse().id_token;
                var accessToken = user.getAuthResponse().access_token;
                AwsCognito.ggConnect(idToken, false, accessToken, function(resp, status){
                    Preloader.close();
                    if( status == 200 ){
                        var cognitoData = {
                            id_token: resp.data.user.cognito_id_token,
                            gg_token: resp.data.user.gg_token
                        };

                        // set cognito credentials
                        AwsCognito.setCredentials(cognitoData, resp.data.user, resp.data.credits);

                        // get credit
                        User.getCredit(function(){
                
                            // this will go to intended or landing page
                            Auth.redirectIfLoggedIn();
                        });
                    }
                    else if( status == 500 ){
                        Popup.error('Google Login has not been supported yet');
                    }
                    else {
                        Popup.error(resp.data.message);
                    }
                });
            };

            /**
             * Handle sign-in failures.
             */
            var onFailure = function(error) {
                Preloader.close();
                //Popup.error(error);
            }; 

            initClient();
        }

        $scope.googleLogin();
    }]);